// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__7HDgn","paramInput":"JobSimulator_paramInput__3YDOL","input":"JobSimulator_input__16-RH"};